import { Component, EventEmitter, Input, ElementRef, Output, ViewChild } from '@angular/core';
import { MzBaseModal } from 'ngx-materialize';
import { campos } from 'src/app/_models/formularios/campos.model';

@Component({
  selector: 'app-deletemodal-campo',
  templateUrl: './deletemodal-campo.component.html'

})
export class DeletemodalCampoComponent extends MzBaseModal {
  public isOnChange: boolean;
  // datos de entrada por el servicio de modal
  @Input() public modal_title: string;
  @Input() public modal_body: string;
  @Input() public isComents: boolean = true;
  @Output() onOkModalComment: EventEmitter<String>;

  @ViewChild("inputComent")
  private comentField: ElementRef;
  public modal_comentario: string;

  public modalOptions: Materialize.ModalOptions = {
    dismissible: false,
    opacity: .5,
    inDuration: 300,
    outDuration: 200,
    startingTop: '100%',
    endingTop: '10%'
  }
  public id: number;
  public campo: campos;

  constructor() {
    super();
    this.onOkModalComment = new EventEmitter();
  }

  ngOnInit() {
    this.campo=new campos();
  }
  public closeModal() {
        
    // si no cometario omite esta parte
    if( this.isComents ) {
        this.modal_comentario='eliminado';
        // no deja salir si no tiene comentario 
        if( this.modal_comentario == null || this.modal_comentario == '') { 
          this.comentField.nativeElement.focus();           
          return;
        }

        this.onOkModalComment.emit(this.modal_comentario)
        this.modal_comentario ='';
        this.isComents= false;
      }
      
    this.modalComponent.closeModal();
  }
}
